import {
    InternalLink,
    ProgressBarContainer,
    ProgressBarFill,
    TotalBox,
    TotalLabel,
    TotalValue,
    TotalsGrid,
    TotalsInner,
    TotalsSection,
} from "../custom-styles/TotalsSection.styles";
import PropTypes from "prop-types";
import React, { useMemo } from "react";

import CircularProgress from "@material-ui/core/CircularProgress";
import { isSameDay } from "date-fns";

function TotalsSectionComponent({ dailyTotalsData, selectedDate, isLoading }) {
    // Calculate daily total from API data
    const dailyTotal = useMemo(() => {
        if (!dailyTotalsData?.data) {
            return 0;
        }

        // Find the entry for the selected date (API returns date and totalHours in lowercase)
        const dayEntry = dailyTotalsData.data.find((entry) =>
            isSameDay(new Date(entry.date), selectedDate)
        );

        return dayEntry?.totalHours || 0;
    }, [dailyTotalsData?.data, selectedDate]);

    // Calculate weekly total from API data
    const weeklyTotal = useMemo(() => {
        if (!dailyTotalsData?.data) {
            return 0;
        }

        // Sum all daily totals for the week
        const total = dailyTotalsData.data.reduce(
            (sum, entry) => sum + (entry.totalHours || 0),
            0
        );

        return total;
    }, [dailyTotalsData?.data]);

    // Calculate daily completion percentage (8 hours = 100%)
    const completionPercentage = Math.min((dailyTotal / 8) * 100, 100);

    return (
        <TotalsSection>
            <TotalsInner>
                <TotalsGrid>
                    <TotalBox>
                        <TotalLabel>Daily Total</TotalLabel>
                        {isLoading ? (
                            <CircularProgress
                                size={16}
                                thickness={4}
                                style={{ color: "#9ca3af", margin: "0 auto" }}
                            />
                        ) : (
                            <TotalValue>{dailyTotal} Hours</TotalValue>
                        )}
                    </TotalBox>
                    <TotalBox>
                        <TotalLabel>Weekly Total</TotalLabel>
                        {isLoading ? (
                            <CircularProgress
                                size={16}
                                thickness={4}
                                style={{ color: "#9ca3af", margin: "0 auto" }}
                            />
                        ) : (
                            <TotalValue>{weeklyTotal} Hours</TotalValue>
                        )}
                    </TotalBox>
                </TotalsGrid>
                <ProgressBarContainer>
                    <ProgressBarFill percentage={completionPercentage} />
                </ProgressBarContainer>
                <InternalLink to="/timesheets/employee/timesheet">
                    Open Timesheet
                </InternalLink>
            </TotalsInner>
        </TotalsSection>
    );
}

TotalsSectionComponent.propTypes = {
    dailyTotalsData: PropTypes.shape({
        data: PropTypes.arrayOf(
            PropTypes.shape({
                date: PropTypes.string,
                totalHours: PropTypes.number,
            })
        ),
        isFetching: PropTypes.bool,
    }),
    selectedDate: PropTypes.instanceOf(Date),
    isLoading: PropTypes.bool,
};

export default TotalsSectionComponent;
